import cn from "classnames";
import { NavLink } from "react-router-dom";
import { Badge, type BadgeProps } from "./badge";
import { Count } from "./count";
import { OnOffLabel } from "./on-off-label";

type TabViewProps = {
  to: string;
  label: string;
  className?: string;
  badge?: Omit<BadgeProps, "as">;
  count?: number | null;
  enabled?: boolean;
  end?: boolean;
};

export type TabItem = {
  name: string;
  current?: boolean;
  href: string;
  badge?: Omit<BadgeProps, "as">;
  count?: number | null;
  enabled?: boolean;
  end?: boolean;
};

const navLink = ({ isActive }: { isActive: boolean }) =>
  cn(
    "flex items-center",
    {
      "font-normal text-base text-gray-500 hover:text-gray-700": !isActive,
      "border-transparent  hover:border-gray-300": !isActive,
      "font-semibold text-black": isActive,
      "border-orange-400": isActive,
    },
    "focus:text-black",
    "whitespace-nowrap pb-3 px-1 border-b-3",
    "hover:no-underline",
  );

export const Tab = ({
  label,
  to,
  badge,
  count,
  enabled,
  end,
}: TabViewProps) => (
  <NavLink key={label} to={to} end={end} className={navLink}>
    <span className="flex items-center gap-2">
      {label}
      {count !== undefined && <Count n={count} />}
      {badge && <Badge {...badge} />}
      {enabled !== undefined && <OnOffLabel on={enabled} />}
    </span>
  </NavLink>
);

export const Tabs = ({ tabs }: { tabs: TabItem[] }) => {
  return (
    <nav
      className="flex space-x-8 bg-white border-black-100 border-b"
      aria-label="Tabs"
    >
      {tabs.map((tab) => (
        <Tab
          key={tab.name}
          label={tab.name}
          to={tab.href}
          badge={tab.badge}
          count={tab.count}
          enabled={tab.enabled}
          end={tab.end}
        />
      ))}
    </nav>
  );
};
